<article
  class="group box-border flex h-full flex-col overflow-hidden rounded-md border border-(--border-subtle) bg-white shadow-(--shadow-card) transition duration-200 hover:-translate-y-0.5 hover:shadow-(--shadow-raised)">
  @if (opportunity().coverImageUrl; as cover) {
    <div class="h-28 overflow-hidden">
      <div class="h-full w-full bg-cover bg-center transition-transform duration-500 ease-out group-hover:scale-110"
        [style.background-image]="'url(' + cover + ')'"></div>
    </div>
  }

  <div class="flex flex-1 flex-col gap-2.5 p-5">
  <div class="flex items-center justify-between gap-2">
    <span
      class="inline-flex h-6 items-center whitespace-nowrap rounded-full px-2.75 text-[12.5px] font-bold"
      [style.background]="toneStyle().bg" [style.color]="toneStyle().fg">
      {{ 'opportunities.types.' + opportunity().tone | translate }}
    </span>

    <button type="button" (click)="toggleSave.emit(opportunity().opportunityId)"
      [attr.aria-pressed]="saved()"
      [attr.aria-label]="(saved() ? 'opportunities.removeFromFavorites' : 'opportunities.saveOpportunity') | translate: { title: opportunity().title }"
      [class]="saved() ? 'text-(--pnud-bleu)' : 'text-(--gris-300) hover:text-(--pnud-bleu)'"
      class="cursor-pointer border-0 bg-transparent p-1 transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--pnud-bleu)">
      <svg width="20" height="20" viewBox="0 0 24 24" [attr.fill]="saved() ? 'currentColor' : 'none'"
        stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true">
        <path d="M19 21l-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
      </svg>
    </button>
  </div>

  <h3 class="m-0">
    <button type="button" (click)="open.emit(opportunity().id)"
      class="cursor-pointer border-0 bg-transparent p-0 text-left text-[15.5px] font-extrabold leading-[1.35] text-(--text-body) hover:text-(--pnud-bleu) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--pnud-bleu)">
      {{ opportunity().title }}
    </button>
  </h3>

  <p class="m-0 text-[13px] text-(--text-muted)">
    {{ opportunity().org }} · {{ (opportunity().regionCode ? ('regions.' + opportunity().regionCode) : 'opportunities.allRegions') | translate }}
  </p>

  <div class="mt-auto flex items-center justify-between gap-2 border-t border-(--border-subtle) pt-2">
    <span class="text-[12.5px] font-bold"
      [class]="opportunity().urgent ? 'text-(--state-danger)' : 'text-(--text-muted)'">
      {{ 'opportunities.deadlinePrefix' | translate }}
      {{ opportunity().closingDate ? (opportunity().closingDate | localizedDate: { day: 'numeric', month: 'short', year: 'numeric' }) : ('opportunities.deadlineNotSet' | translate) }}
    </span>

    <button type="button" (click)="open.emit(opportunity().id)"
      class="box-border inline-flex h-8.5 cursor-pointer items-center rounded-sm border border-(--pnud-bleu) bg-transparent px-3.5 text-[13.5px] font-bold text-(--pnud-bleu) transition hover:bg-(--surface-primary-tint) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--pnud-bleu)">
      {{ (opportunity().applicationsEnabled ? 'opportunities.apply' : 'opportunities.viewDetails') | translate }}
    </button>
  </div>
  </div>
</article>
